import React from 'react';
import { connect } from 'react-redux';
import ToolTip from 'react-portal-tooltip';
import Timestamp from "react-timestamp"
import ReactTooltip from 'react-tooltip';
import moment from "moment"
import { createSelectable } from 'react-selectable-fast-forked'
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash'
export class Sensor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tooltipOpen: false
		}
	}
	onMouseEnter() {
		// only display tooltip on view or selected mode
		if (this.props.selectingMode === "view" || this.props.selectingMode === "selected") {
			this.setState({ tooltipOpen: true })
		}

	}
	onMouseLeave() {
		this.setState({ tooltipOpen: false })
	}

	render() {

		let props = this.props;
		const { color, sensor, viewFilter, thumbnail, selectableRef, selected } = props;

		let style = { left: sensor.xpercent + '%', top: sensor.ypercent + '%' };
		let className = 'point';

		var sensorConfig = this.props.configMap[sensor.macaddress];

		// sensor will be blink if there is a difference between ‘read value’ and ‘sent value’
		if (!isEmpty(sensorConfig.pendingConfig)) {
			className += ' pending'
		}

		if (selected) {
			className += ' selected'
		}

		//------------------------------filter condition------------------------
		// default live view color for sensor
		if (sensor.registered && (sensor.lastonl + 24 * 60 * 60 > moment().unix())) {
			if (sensor.faulty) {
				className += ' faulty';
			} else {
				if (sensor.inuse) {
					className += ' inuse';
				} else if (sensor.standby) {
					className += ' standby';
				}
			}
		} else {
			className += ` unregistered`
		}
		// Filter out sensors
		if (viewFilter) {
			if (viewFilter.code == "LIVE" && (!sensor.registered || sensor.faulty)) {
				// hide broken / unregistered sensor in live view.
				className += ` hidden`;
			}
			if (viewFilter.code == "MAINTENANCE" && (sensor.registered && !sensor.faulty)) {
				// hide good and registered sensor in maintenance view.
				className += ` hidden`;
			}

		}
		// Filter configuration view
		viewFilter.code === "CONFIGURATION" && (style.backgroundColor = color)
		if (!thumbnail) {
			return (
				<React.Fragment>
					<div
						ref={selectableRef}
						className={className} style={style}
						id={"sensor" + sensor.id}
						onMouseEnter={() => this.onMouseEnter()}
						onMouseLeave={() => this.onMouseLeave()}
					//onClick={(e) => { this.props.onClickNode(e, sensor) }}
					/>
					<ToolTip
						tooltipTimeout={100}
						active={this.state.tooltipOpen} parent={"#sensor" + sensor.id} position="right" arrow="center"
						style={{
							style: {
								background: "rgba(0,0,0,.9)",
								padding: 10,
								color: "#EEE",
								boxShadow: "0px 4px 6px rgba(0,0,0,.3)",
								borderRadius: 4
							},
							arrowStyle: {
								color: 'rgba(0,0,0,.8)',
								borderColor: false
							}
						}}
					>
						<table><tbody><tr>
							<td>
								<div>{sensor.name}</div>
								<div>{sensor.macaddress.toUpperCase()}</div>
								{
									(!sensor.registered) ?
										<div> Maintenance {/*Change from Unregistered to Maintenance*/} </div>
										:
										(sensor.faulty ? <div>Offline since <Timestamp time={sensor.lastonl} /></div> : "")
								}
							</td>
						</tr></tbody></table>
					</ToolTip>
				</React.Fragment>
			)
		}
		else {
			return (
				<div ref={selectableRef}>
					<div className={className} style={style}
						data-tip data-for={"sensor" + sensor.id}
					/>
					<ReactTooltip id={"sensor" + sensor.id} place="right" type="dark" effect="solid">
						{sensor.name}<br />
						{sensor.macaddress.toUpperCase()}
					</ReactTooltip>
				</div>
			);
		}
	}
}
function mapStateToProps(state) {
	return {
		nodeMap: state.overviewReducer.nodeMap,
		configMap: state.devManReducer.configMap
	}
}
function mapDispatchToProps(dispatch) {
	return {
		dispatch
	}
}
Sensor.propTypes = {
	nodeMap: PropTypes.object.isRequired,
	sensor: PropTypes.object.isRequired,
	viewFilter: PropTypes.object,
	//onClickNode: PropTypes.func.isRequired,
	thumbnail: PropTypes.bool.isRequired
}
export default connect(mapStateToProps, mapDispatchToProps)(createSelectable(Sensor));



// WEBPACK FOOTER //
// ./src/components/pages/devicemanagement/sensor.jsx